import { render, staticRenderFns } from "./Plot.vue?vue&type=template&id=65d4ece4&scoped=true&"
import script from "./Plot.vue?vue&type=script&lang=js&"
export * from "./Plot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4ece4",
  null
  
)

export default component.exports